export default "__VITE_ASSET__BZCEBNRa__"